import actions from './actions'
import getters from './getters.js'
import Vue from 'vue'

const state = {
  facets: {},
  searchQuery: '',
  referenceQuery: null,
  query: {},
  filters: {},
  rangeFilters: {},
  resourceType: null
}
const mutations = {
  SET_RESOURCE_FACETS (state, action) {
    state.facets = { ...state.facets, [action.facet]: action.facetData }
  },
  SET_CHECKED_FACET (state, action) {
    state.facets[action.facet][action.index].isChecked = !state.facets[action.facet][action.index].isChecked
    state.facets = { ...state.facets, [action.facet]: state.facets[action.facet] }
  },
  SET_SEARCH_QUERY (state, action) {
    state.searchQuery = action.query
  },
  SET_REFERENCE_QUERY (state, action) {
    state.referenceQuery = action.query
  },
  SET_QUERY_ARRAY_FACETS (state, action) {
    const queryObject = {}
    if (action.queryArrayFacet != null) {
      action.queryArrayFacet.forEach((values) => {
        if (values.length > 0) {
          let facetValue = ''
          if (values[0].facet.includes('refinementList')) {
            facetValue = values[0].facet.split('=')[1]
          } else {
            facetValue = values[0].facet
          }
          queryObject[`refinementList=${facetValue}`] = (values.map(({ value }) => value).join('~'))
        }
      })
    }
    Object.keys(state.query).forEach((key) => {
      if (key.includes('refinementList=')) {
        if (Object.keys(queryObject).indexOf(key) < 0) {
          delete state.query[key]
        }
      }
    })
    state.query = { ...state.query, ...queryObject }
    Object.keys(state.query).forEach((key) => {
      if (state.query[key] === null) {
        delete state.query[key]
      }
    })
  },
  SET_QUERY_NUMERIC_FILTER (state, action) {
    const queryObject = {}
    if (action.queryNumericFilter != null) {
      Object.keys(action.queryNumericFilter).forEach((key) => {
        queryObject[`numericFilters=${key}`] = (action.queryNumericFilter[key].map((value) => value).join('~'))
      })
    }
    state.query = { ...state.query, ...queryObject }

    Object.keys(state.query).forEach((key) => {
      if (state.query[key] === null) {
        delete state.query[key]
      }
    })
  },
  SET_QUERY_RANGE_FILTER (state, action) {
    const queryObject = {}
    if (action.queryRangeFilter != null) {
      Object.keys(action.queryRangeFilter).forEach((key) => {
        queryObject[`rangeFilters=${key}`] = `${action.queryRangeFilter[key].from}~${action.queryRangeFilter[key].to}`
      })
    }
    state.query = { ...state.query, ...queryObject }

    Object.keys(state.query).forEach((key) => {
      if (state.query[key] === null) {
        delete state.query[key]
      }
    })
  },
  SET_QUERY_PAGE (state, action) {
    const queryObject = {}
    if (action.queryPage !== 0 && action.queryPage != null) {
      queryObject[`page`] = action.queryPage
    }
    state.query = { ...state.query, ...queryObject }

    Object.keys(state.query).forEach((key) => {
      if (state.query[key] === null) {
        delete state.query[key]
      }
    })
  },
  SET_QUERY_SEARCH_TEXT (state, action) {
    const queryObject = {}
    if (action.querySearchText != null) {
      if (action.querySearchText.length > 0) {
        queryObject[`wrld_query`] = action.querySearchText
      } else {
        queryObject[`wrld_query`] = null
      }
    }
    state.query = { ...state.query, ...queryObject }

    Object.keys(state.query).forEach((key) => {
      if (state.query[key] === null) {
        delete state.query[key]
      }
    })
  },
  SET_QUERY_SEARCH_REF (state, action) {
    const queryObject = {}
    if (action.queryRefSearch != null) {
      if (action.queryRefSearch.length > 0) {
        queryObject[`wrld_ref`] = action.queryRefSearch
      } else {
        queryObject[`wrld_ref`] = null
      }
    }
    state.query = { ...state.query, ...queryObject }

    Object.keys(state.query).forEach((key) => {
      if (state.query[key] === null) {
        delete state.query[key]
      }
    })
  },
  SET_DATE_FILTER (state, action) {
    state.filters = {...state.filters, [action.attribute]: action.value}
  },
  CLEAR_FILTER_FACET_VALUE (state, action) {
    // Remove facet values from URL
    let values = state.query[`refinementList=${action.facet}`].split('~')
    const removedValueIndex = values.indexOf(action.value)
    if (removedValueIndex >= 0) {
      values.splice(removedValueIndex, 1)
      if (values.length < 1) {
        Vue.delete(state.query, [`refinementList=${action.facet}`])
      } else {
        let queryObject = {}
        queryObject[`refinementList=${action.facet}`] = (values.map((value) => value).join('~'))
        console.log(queryObject)
        state.query = { ...state.query, ...queryObject }
      }
    }

    const valueIndex = state.facets[action.facet].findIndex(({ value }) => value === action.value)
    if (valueIndex >= 0) {
      state.facets[action.facet][valueIndex].isChecked = false
      state.facets = { ...state.facets, [action.facet]: state.facets[action.facet] }
    }
  },
  CLEAR_ALL_FILTERS (state, action) {
    Object.keys(state.query).forEach((key) => {
      const index = action.notClearable.findIndex((value) => (key.indexOf(value) >= 0))
      if ( index < 0) {
        Vue.delete(state.query, [key])
      }
    })
    const allFacets = { ...state.facets }
    Object.keys(allFacets).forEach((key) => {
      state.facets[key].forEach((facet, index) => {
        facet.isChecked = false
        state.facets[key][index] = { ...facet }
      })
    })
    Object.keys(state.rangeFilters).forEach((key) => {
      Vue.delete(state.rangeFilters, [key])
    })
  },
  CLEAR_SPECIFIC_FACET_VALUE (state, action) {
    const index = state.facets[action.facet].findIndex(({ value }) => {
      value === action.value
    })
    let newFacet = { ...state.facets[action.facet] }
    if (index >= 0) {
      newFacet[index].isChecked = false
      state.facets[action] = { ...newFacet }
    }
  },
  SET_RANGE_FILTER (state, action) {
    state.rangeFilters = { ...state.rangeFilters, [action.attribute]: action.value }
  },
  CLEAR_RANGE_FILTER (state, action) {
    Vue.delete(state.rangeFilters, [action.rangeType])
    Vue.delete(state.query, [`rangeFilters=${action.rangeType}`])
  },
  SET_RESOURCE_INDEX (state, action) {
    state.resourceIndex = action.index
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
